// Filtres partages des sous-vues "Usage" et "Statistiques" de la page Usage des vues (BI-693).
import moment from "moment";
import React from "react";
import { DatePicker, Select } from "antd";

import { optionsEnvironnements, optionsServeurs } from "./usageVuesFormat";

export const FMT = "YYYY-MM-DD";
export const periodeDefaut = () => [moment().subtract(30, "days"), moment()];

// Parametres d'API communs a /api/usage/views et /api/usage/stats (null si periode incomplete).
export function construireParams(periode, serveur, env, module) {
  if (!periode || !periode[0] || !periode[1]) return null;
  const params = { from: periode[0].format(FMT), to: periode[1].format(FMT) };
  if (serveur) params.hostname = serveur;
  if (env) params.environnement_code = env;
  if (module) params.module = module;
  return params;
}

const opts = (l) => l.map((v) => ({ value: v, label: v }));

// Serveur et Environnement : deux filtres independants, listes en cascade (BI-695).
export default function UsageFiltres({ periode, setPeriode, serveur, setServeur, env, setEnv, module, setModule, couples, modules }) {
  const serveurs = optionsServeurs(couples, env);
  const envs = optionsEnvironnements(couples, serveur);
  // une selection devenue incompatible avec l'autre filtre est videe
  const choisirServeur = (v) => {
    setServeur(v);
    if (v && env && !optionsEnvironnements(couples, v).includes(env)) setEnv(undefined);
  };
  const choisirEnv = (v) => {
    setEnv(v);
    if (v && serveur && !optionsServeurs(couples, v).includes(serveur)) setServeur(undefined);
  };
  return (
    <div className="usage-filtres" style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
      <DatePicker.RangePicker
        aria-label="Période"
        value={periode}
        format="DD/MM/YYYY"
        allowClear={false}
        onChange={(v) => v && setPeriode(v)}
      />
      <Select
        aria-label="Serveur"
        placeholder="Tous les serveurs"
        allowClear
        showSearch
        optionFilterProp="label"
        style={{ minWidth: 200 }}
        value={serveur}
        onChange={choisirServeur}
        options={opts(serveurs)}
      />
      <Select
        aria-label="Environnement"
        placeholder="Tous les environnements"
        allowClear
        showSearch
        optionFilterProp="label"
        style={{ minWidth: 200 }}
        value={env}
        onChange={choisirEnv}
        options={opts(envs)}
      />
      <Select
        aria-label="Module"
        placeholder="Tous les modules"
        allowClear
        style={{ minWidth: 180 }}
        value={module}
        onChange={setModule}
        options={modules.map((m) => ({ value: m.code, label: m.label }))}
      />
    </div>
  );
}
